import { staticText } from '../../../utils/translations/staticText';

export default staticText({
  chooseSsReward: {
    _: '1. Choose Your MoneyHero Reward',
    zh: '1. 選擇你的MoneyHero獎賞',
  },
  brand_reward_guidance: {
    _: "MoneyHero's reward",
    zh: 'MoneyHero 獨家獎勵',
  },
  reward_modal_loan_amount_with_end: {
    _: ':label :start - :end',
    zh: ':label :start - :end',
  },
  reward_modal_loan_amount_without_end: {
    _: ':label :start',
    zh: ':label :start',
  },
  reward_modal_tenure_with_end: {
    _: ':label :start - :end month tenure',
    zh: ':label :prefix:start :suffix - :prefix:end :suffix',
  },
  reward_modal_tenure_without_end: {
    _: ':label :start month tenure :suffix',
    zh: ':label :start :suffix',
  },
});
